module.exports = __webpack_public_path__ + "static/media/backEmblem.b57bf610.svg";